// Whether the browser draws without a GPU (acceleration off or blocklisted, remote or virtual desktops). A
// backdrop-filter then costs 60 to 100 ms on every frame where anything under or in its element repaints: an open
// modal with a frosted panel scrolled at 15 fps. Told by the WebGL renderer, which falls back to a software one
// (SwiftShader, llvmpipe, Microsoft Basic Render Driver) or is missing.
const SOFTWARE_RENDERERS = /swiftshader|llvmpipe|softpipe|basic render|software/i;

let softwareRendering: boolean | null = null;

const detect = () => {
  try {
    const canvas = document.createElement("canvas");
    const gl = canvas.getContext("webgl") ?? canvas.getContext("experimental-webgl");
    if (!(gl instanceof WebGLRenderingContext)) return true;
    const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    const renderer = gl.getParameter(debugInfo ? debugInfo.UNMASKED_RENDERER_WEBGL : gl.RENDERER);
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return SOFTWARE_RENDERERS.test(String(renderer));
  } catch {
    return false;
  }
};

export const isSoftwareRendering = () => {
  if (softwareRendering === null) {
    softwareRendering = detect();
    // Drops every other backdrop blur of the app (app.css)
    document.documentElement.classList.toggle("software-rendering", softwareRendering);
  }
  return softwareRendering;
};

// Found while the browser is idle, before the first modal opens
if (typeof window !== "undefined") {
  const whenIdle = window.requestIdleCallback ?? ((callback: () => void) => window.setTimeout(callback, 2000));
  whenIdle(() => isSoftwareRendering());
}
